import type React from "react";
import {
  NativeSelect as ShadcnNativeSelect,
  NativeSelectOptGroup as ShadcnNativeSelectOptGroup,
  NativeSelectOption as ShadcnNativeSelectOption,
} from "src/shadcn/components/native-select";

const NativeSelect = (
  props: React.ComponentProps<typeof ShadcnNativeSelect>
) => <ShadcnNativeSelect {...props} />;

const NativeSelectOptGroup = (
  props: React.ComponentProps<typeof ShadcnNativeSelectOptGroup>
) => <ShadcnNativeSelectOptGroup {...props} />;

const NativeSelectOption = (
  props: React.ComponentProps<typeof ShadcnNativeSelectOption>
) => <ShadcnNativeSelectOption {...props} />;

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
